module.exports = __webpack_public_path__ + "img/support-savedsearch.1bae4ecf.png";